import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-uparrow",
  "use": "icon-uparrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-uparrow\"><path d=\"M898.54 743.46L512 356.91 125.46 743.46a36 36 0 0 1-50.92-50.92l412-412A35.92 35.92 0 0 1 512 270a35.9 35.9 0 0 1 18 4.84l1.16 0.71a36 36 0 0 1 6.27 5l412 412a36 36 0 0 1-50.91 50.92z\" p-id=\"3289\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol